import React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { ButtonWithIcon } from 'src/v2/components/ui/buttons/buttonWithIcon';
import { GenericInfoLabel } from 'src/v2/components/ui/label';

import { useAllVaultData } from '~components/hooks/protocol/vaults/useAllVaultData';
import { primaryColors, secondaryColors } from '~components/theme/styles/colors';
import { EDisplayType } from '~components/types';
import { displayFormatUnits } from '~components/utils/utils';

import SlideWrapper from '../SlideWrapper';

function SecureLiquidationsSlide() {
  const {
    computed: { totalSystemDebtVst },
  } = useAllVaultData();

  //@todo VFF SAVING MODULE V2
  const safetyVaultTotalVst = 4206900;

  return (
    <SlideWrapper
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Typography textAlign={{ xs: 'center', sm: 'left' }} variant={'h4'} mb={4}>
        Liquidations are fully secured
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} mb={4}>
        <Stack spacing={4} width={'100%'}>
          <GenericInfoLabel
            variant="vertical"
            labelTitle="FIRST LINE OF DEFENSE"
            labelValueVariant={'h6'}
            labelValue={'Asset-specific Stability Pools'}
          />
          <Typography variant={'body1'} color={primaryColors[400]}>
            VST in stability pools ensures immediate liquidation of underwater positions
          </Typography>
          <GenericInfoLabel
            variant="vertical"
            labelTitle="AMOUNT IN STABILITY POOL"
            labelValueVariant={'h6'}
            labelValue={displayFormatUnits({
              value: totalSystemDebtVst - safetyVaultTotalVst,
              displayType: EDisplayType.USD,
            })}
          />
          <ButtonWithIcon iconType="asterisk"> Learn More </ButtonWithIcon>
        </Stack>
        <Box
          sx={{
            borderLeft: { xs: undefined, sm: `1px solid ${secondaryColors[200]}` },
            borderBottom: { xs: `1px solid ${secondaryColors[200]}`, sm: undefined },
          }}
        />
        <Stack spacing={4} width={'100%'}>
          <GenericInfoLabel
            variant="vertical"
            labelTitle="SECOND LINE OF DEFENSE"
            labelValueVariant={'h6'}
            labelValue={'Saving Module'}
          />
          <Typography variant={'body1'} color={primaryColors[400]}>
            Locked capital in saving module fully guarantees liquidation
          </Typography>
          <GenericInfoLabel
            variant="vertical"
            labelTitle="AMOUNT IN SAVING MODULE"
            labelValueVariant={'h6'}
            labelValue={displayFormatUnits({ value: safetyVaultTotalVst, displayType: EDisplayType.USD })}
          />
          <ButtonWithIcon iconType="asterisk"> Learn More </ButtonWithIcon>
        </Stack>
      </Stack>
    </SlideWrapper>
  );
}

export default SecureLiquidationsSlide;
